import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
    GET_PORTAL_LINKS,
    ADD_PORTAL_LINK,
    UPDATE_PORTAL_LINK,
    DELETE_PORTAL_LINK,
} from './actionTypes';
import {
    getPortalLinksSuccess,
    getPortalLinksFail,
    addPortalLinkSuccess,
    addPortalLinkFail,
    updatePortalLinkSuccess,
    updatePortalLinkFail,
    deletePortalLinkSuccess,
    deletePortalLinkFail,
    setPortalLinksFieldErrors,
} from './actions';
import axiosInstance from 'pages/Utility/axiosInstance';
import { showSuccess } from 'helpers/notification_helper';

// API Calls
const fetchPortalLinksApi = (params) => axiosInstance.post('V1/portallinks/list', params);
const addPortalLinkApi = ({ data }) => axiosInstance.post('V1/portallinks/create', data);
const updatePortalLinkApi = ({ data, id }) => axiosInstance.post(`V1/portallinks/update/${id}`, data);
const deletePortalLinkApi = (id) => axiosInstance.post(`V1/portallinks/${id}`);

// Sagas
function* getPortalLinksSaga(action) {
    try {
        const { data } = yield call(fetchPortalLinksApi, action.payload);
        yield put(getPortalLinksSuccess(data));
    } catch (error) {
        yield put(getPortalLinksFail(error.response?.data || error.message));
    }
}

function* addPortalLinkSaga(action) {
    try {
        const { data } = yield call(addPortalLinkApi, action.payload);
        yield put(addPortalLinkSuccess(data));

        action.payload.resetForm();
        action.payload.handleClose();

        showSuccess('Portal Link added successfully!');
    } catch (error) {
        if (error.response?.status === 400 && error.response?.data?.errors) {
            yield put(setPortalLinksFieldErrors(error.response.data.errors));
        } else {
            yield put(addPortalLinkFail(error.response?.data || error.message));
        }
    }
}

function* updatePortalLinkSaga(action) {
    try {
        const { data } = yield call(updatePortalLinkApi, action.payload);
        yield put(updatePortalLinkSuccess(data));

        action.payload.resetForm();
        action.payload.handleClose();

        showSuccess('Portal Link updated successfully!');
    } catch (error) {
        if (error.response?.status === 400 && error.response?.data?.errors) {
            yield put(setPortalLinksFieldErrors(error.response.data.errors));
        } else {
            yield put(updatePortalLinkFail(error.response?.data || error.message));
        }
    }
}

function* deletePortalLinkSaga(action) {
    try {
        yield call(deletePortalLinkApi, action.payload);
        yield put(deletePortalLinkSuccess(action.payload));
        showSuccess('Portal Link deleted successfully!');
    } catch (error) {
        yield put(deletePortalLinkFail(error.response?.data || error.message));
    }
}

// Watcher Saga
function* portalLinksSaga() {
    yield takeLatest(GET_PORTAL_LINKS, getPortalLinksSaga);
    yield takeEvery(ADD_PORTAL_LINK, addPortalLinkSaga);
    yield takeEvery(UPDATE_PORTAL_LINK, updatePortalLinkSaga);
    yield takeEvery(DELETE_PORTAL_LINK, deletePortalLinkSaga);
}

export default portalLinksSaga;
